import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { pbPreferredPricing } from '../../../../../constants/PricingBenefits';
var handleMultiLines = function (text) { return (React.createElement(React.Fragment, null, text === null || text === void 0 ? void 0 :
    text.line1,
    (text === null || text === void 0 ? void 0 : text.line2) && (React.createElement(React.Fragment, null,
        React.createElement("br", null), text === null || text === void 0 ? void 0 :
        text.line2)))); };
var getBlurbText = function (isQualified, isHDPassVerbageEnabled) {
    var ppBlurbs = isHDPassVerbageEnabled
        ? pbPreferredPricing.ppBlurbsHDPass
        : pbPreferredPricing.ppBlurbs;
    var textPreQualified = [ppBlurbs.unlockPrefPricing];
    var textQualified = [
        ppBlurbs.shopScanSave,
        ppBlurbs.projectPriority,
        ppBlurbs.savingsThatGrow,
    ];
    return isQualified ? textQualified : textPreQualified;
};
var BlurbTitle = function (_a) {
    var isMobile = _a.isMobile, children = _a.children;
    return isMobile ? (React.createElement("div", { className: "sui-text-lg sui-font-bold", "data-testid": "PrefPricingBlurbs__BlurbTitle__Mobile" }, children)) : (React.createElement("p", { className: "sui-border-b-1 sui-border-solid sui-border-primary sui-pb-1 sui-text-4xl sui-mt-4", "data-testid": "PrefPricingBlurbs__BlurbTitle__Desktop" }, children));
};
var BlurbContent = function (_a) {
    var content = _a.content;
    return (React.createElement("p", { "data-testid": "BlurbContent", className: "sui-text-base lg:sui-text-lg sui-py-3", style: { maxWidth: '770px' } }, handleMultiLines(content)));
};
var BlurbBodyDT = function (_a) {
    var isQualified = _a.isQualified;
    var isHDPassVerbageEnabled = ['1', 1].includes(useConfigService('ENABLE_HD_PASS_VERBAGE'));
    var array = getBlurbText(isQualified, isHDPassVerbageEnabled);
    return (React.createElement("div", { className: "sui-pt-5" }, array.map(function (data, i) {
        var _a, _b, _c;
        return (React.createElement("div", { key: i, className: "" },
            React.createElement(BlurbTitle, null, (_a = data === null || data === void 0 ? void 0 : data.title) === null || _a === void 0 ? void 0 :
                _a.line1,
                ((_b = data === null || data === void 0 ? void 0 : data.title) === null || _b === void 0 ? void 0 : _b.line2) && " ".concat((_c = data === null || data === void 0 ? void 0 : data.title) === null || _c === void 0 ? void 0 : _c.line2)),
            React.createElement(BlurbContent, { content: data === null || data === void 0 ? void 0 : data.content })));
    })));
};
var BlurbBodyMW = function (_a) {
    var isQualified = _a.isQualified;
    var isHDPassVerbageEnabled = ['1', 1].includes(useConfigService('ENABLE_HD_PASS_VERBAGE'));
    var array = getBlurbText(isQualified, isHDPassVerbageEnabled);
    return (React.createElement("div", { className: "sui-pt-5" }, array.map(function (data, i) { return (React.createElement("div", { key: i, className: "" },
        React.createElement(BlurbTitle, { isMobile: true }, handleMultiLines(data === null || data === void 0 ? void 0 : data.title)),
        React.createElement(BlurbContent, { content: data === null || data === void 0 ? void 0 : data.content }))); })));
};
export var PrefPricingBlurbs = function (props) {
    var isMobile = props.isMobile, isQualified = props.isQualified;
    var FinalRender = function () {
        return isMobile ? (React.createElement(BlurbBodyMW, { isQualified: isQualified })) : (React.createElement(BlurbBodyDT, { isQualified: isQualified }));
    };
    return (React.createElement("div", { className: "" },
        React.createElement(FinalRender, null)));
};
